import script from "./CursorEffect.vue?vue&type=script&setup=true&lang=js"
export * from "./CursorEffect.vue?vue&type=script&setup=true&lang=js"

import "./CursorEffect.vue?vue&type=style&index=0&id=738dc5c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-738dc5c0"]])

export default __exports__